module.exports = __webpack_public_path__ + "static/media/image.b55b57e8.svg";